package org.example.zone360.components

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetClubWidgetDataResponse(
    val selectedWidgets: List<String>,
)


@Serializable
data class GetClubWidgetPayload(
    val organization: String,
    val userId: String? = null,
)

